module.exports = __webpack_public_path__ + "img/search-lite.985b945b.svg";